import { Component, Vue } from 'vue-facing-decorator'
import ax from '@/utils/axios_non'
import { ref } from 'vue'

@Component({
  components: {}
})
export default class Register extends Vue {
  is_loading = false
  errors : any = ref({})
  success: any = false
  error: any = false
  roles: any = ref([])
  //-------------------------------------------
  username: any = ref('')
  email: any = ref('')
  name: any = ref('')
  password: any = ref('')
  confirm_password: any = ref('')
  user_roles: any = ref([])
  //-------------------------------------------

  public mounted() {
    this.getRoles()
    //set backround
    if (this.app_base_data.img_background != '') {
      document.body.style.backgroundImage = `url('${this.app_base_data.img_background}')`
    }
  }

  get app_base_data(): any {
    return this.$store.state.baseData
  }

  get app_base_config(): any {
    return this.$store.getters['baseConfig/getConfig']
  }

  async getRoles() {
    await ax
      .get('admin/get_roles')
      .then((res: any) => {
        if (res.data.status) {
          this.roles = res.data.data
            .filter((item: any) => item.name !== 'admin')
            .map((item: any) => {
              return {
                name: item.name,
                value: item.name
              }
            })
        }
      })
      .catch((err: any) => {
        console.log(err)
      })
  }

  async submit() {
    this.error = false
    this.is_loading = true
    const formData = new FormData()
    const url = 'register'
    //---------------------------------------------------------
    formData.append('_method', 'POST')
    formData.append('username', this.username)
    formData.append('email', this.email)
    formData.append('name', this.name)
    formData.append('password', this.password)
    formData.append('confirm_password', this.confirm_password)
    if(this.app_base_config.register.show_role){
      this.user_roles.forEach((item: any) => {
        formData.append('roles[]', item.name)
      })
    }
    //---------------------------------------------------------
    await ax
      .post(url, formData)
      .then((res: any) => {
        //console.log(res)
        this.is_loading = false
        if (res.data.status) {
          this.success = res.data.message
          this.$toast.add({
            severity: 'success',
            summary: 'Create User',
            detail: res.data.message,
            life: 3000
          })
          //----------------------------------------------
          this.errors = false;
          this.error  = false;
          //----------------------------------------------
          this.username = ''
          this.email = ''
          this.name = ''
          this.password = ''
          this.confirm_password = ''
          this.user_roles = []
          //----------------------------------------------
        } else {
          this.$toast.add({
            severity: 'warn',
            summary: 'Create User Failed',
            detail: res.data.message,
            life: 3000
          })
        }
      })
      .catch((err: any) => {
        console.log(err)
        this.is_loading = false;
        this.success = false;
        this.$toast.add({
          severity: 'warn',
          summary: 'Create User Failed',
          detail: err.message,
          life: 3000
        })
        if (err.response) {
          this.error = err.response.data.message
          this.$toast.add({
            severity: 'error',
            summary: err.message,
            detail: err.response.data.message,
            life: 3000
          })
          if (err.response.data.errors) {
            this.errors = err.response.data.errors
          }
        }
      })
  }
}
